/**
 * iq-report-offer.js — оффер платного разбора на экране результата IQ-теста.
 *
 * Тест, балл, перцентиль, доверительный интервал и профиль по доменам остаются
 * бесплатными. Платный артефакт — только скачиваемый документ.
 *
 * Три вещи, ради которых этот файл отдельный, а не десять строк в блейде:
 *
 * 1. ТИЗЕР ПОКАЗЫВАЕТ КАЧЕСТВО, А НЕ ОБЕЩАЕТ ЕГО. Мы запрашиваем у сервера два
 *    НАСТОЯЩИХ объяснения тех заданий, где человек ошибся, и печатаем их прямо
 *    в оффере. Строка «купите подробный разбор» неотличима от такой же строки у
 *    конкурента; два абзаца про задания, которые он только что решал, —
 *    отличимы.
 *
 * 2. РЕЗУЛЬТАТ ПЕРЕЖИВАЕТ РЕГИСТРАЦИЮ. Кошелёк живёт на аккаунте, а 95%
 *    проходящих тест анонимны. Значит между «хочу разбор» и «могу заплатить»
 *    стоит регистрация, и если результат её не переживёт, человек заплатит за
 *    пустоту. Результат кладётся в localStorage ДО ухода на вход и
 *    восстанавливается при возврате.
 *
 * 3. ГРАФИКИ УЕЗЖАЮТ НА СЕРВЕР КАРТИНКАМИ. Колокол и радар уже нарисованы на
 *    этой странице теми же формулами; рисовать их второй раз на PHP значило бы
 *    завести второй источник правды для одной картинки.
 */
(function () {
'use strict';

var CFG = null;              // ответ /api/iq-report/info
var RESULT = null;           // последний результат теста
var SAVE_KEY = 'iq_report_pending_result';
var BUSY = false;
var PURCHASED_URL = null;   // ссылка на уже выданный документ этой сессии
var RUN_SAVED = null;       // промис отложенного прогона: второй раз не шлём
var RUN_FOR = '';           // отпечаток результата, ради которого он отложен
var CLAIMED = false;        // оплаченное уже забрали в этой загрузке страницы
var GATE = null;            // карточка перка: держим ССЫЛКУ, см. relocateGate()

/**
 * Форма результата на СТРАНИЦЕ и форма, которую ждёт сервер, — разные, и это
 * не небрежность: страница считает по-своему исторически (ciLow, clsKey), а
 * серверная модель названа по колонкам таблицы (ci_low, iq_class).
 *
 * Преобразование живёт здесь, в одном месте, и это единственная точка, где две
 * формы встречаются. Без него покупка молча падала бы с 422: балл прошёл бы, а
 * доверительный интервал и класс — нет. Поймано живым прогоном, не чтением.
 *
 * ⚠️ `iq` берётся НЕОКРУГЛЁННЫМ. Телеметрия шлёт балл, округлённый до пяти
 * (r5), и соблазн переиспользовать её payload велик — но в документе обязано
 * стоять ровно то число, которое человек видел на экране. «118 на экране, 120
 * в сертификате» это претензия, а не мелочь.
 */
function toServerShape(r) {
    if (!r) return null;
    return {
        iq: r.iq,
        iq_class: r.clsKey || r.iq_class || '',
        percentile: r.percentile,
        ci_low: (r.ciLow != null ? r.ciLow : r.ci_low),
        ci_high: (r.ciHigh != null ? r.ciHigh : r.ci_high),
        duration_min: (r.duration != null ? r.duration : r.duration_min) || 0,
        cal_version: (window.__IQ_CAL_VERSION || r.cal_version || 0),
        domains: r.domains || {},
        items: r.itemsCsv || r.items || ''
    };
}

/**
 * Отпечаток результата — ровно то, что уехало бы на сервер.
 *
 * Сравниваем СОДЕРЖИМОЕ, а не объект: возраст, указанный на экране
 * результата, пересчитывает балл В ТОМ ЖЕ объекте (IQT.setResultAge), и
 * проверка «тот же объект» объявила бы прогон со старым баллом годным.
 */
function fingerprint(r) {
    try { return JSON.stringify(toServerShape(r)); } catch (e) { return ''; }
}

function T(key, vars) {
    var dict = (window.__IQ_REPORT_T || {});
    var s = dict[key];
    if (typeof s !== 'string') return '';
    if (vars) Object.keys(vars).forEach(function (k) {
        s = s.split(':' + k).join(vars[k]);
    });
    return s;
}

function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
}

function infoUrl() {
    return '/api/iq-report/info?locale=' + encodeURIComponent(window.__LOCALE || document.documentElement.lang || 'en');
}

function csrf() {
    var m = document.querySelector('meta[name="csrf-token"]');
    return m ? m.getAttribute('content') : '';
}

function post(url, body) {
    return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrf(), 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(body || {})
    }).then(function (r) { return r.json().then(function (j) { j.__status = r.status; return j; }); });
}

/* ── Сохранение результата на время регистрации ────────────────────────── */

function stash(result) {
    try {
        localStorage.setItem(SAVE_KEY, JSON.stringify({ at: Date.now(), result: result }));
    } catch (e) { /* приватный режим — тогда просто не переживёт, но не упадём */ }
}

function unstash() {
    try {
        var raw = localStorage.getItem(SAVE_KEY);
        if (!raw) return null;
        var o = JSON.parse(raw);
        // Сутки: возврат «через неделю» к чужому уже результату сбивал бы с толку.
        if (!o || !o.result || (Date.now() - (o.at || 0)) > 86400000) { clearStash(); return null; }
        return o.result;
    } catch (e) { return null; }
}

function clearStash() {
    try { localStorage.removeItem(SAVE_KEY); } catch (e) {}
}

/* ── Разметка ──────────────────────────────────────────────────────────── */

function offerHtml() {
    var h = '<div class="iq-offer" id="iqOffer">';
    h += '<div class="iq-offer-head">';
    h += '<div class="iq-offer-title">' + esc(T('title')) + '</div>';
    h += '<div class="iq-offer-sub">' + esc(T('subtitle')) + '</div>';
    h += '</div>';
    h += '<div class="iq-offer-teaser" id="iqOfferTeaser"></div>';
    h += '<div class="iq-offer-actions" id="iqOfferActions"></div>';
    h += '<div class="iq-offer-status" id="iqOfferStatus" role="status" aria-live="polite"></div>';
    h += '</div>';
    return h;
}

function renderTeaser(items, total) {
    var host = document.getElementById('iqOfferTeaser');
    if (!host || !items || !items.length) return;

    var h = '';
    items.forEach(function (it) {
        h += '<div class="iq-offer-item">';
        h += '<div class="iq-offer-item-head">';
        h += '<span class="iq-offer-domain">' + esc(it.domain) + '</span>';
        h += '<span class="iq-offer-verdict ' + (it.correct ? 'ok' : 'bad') + '">'
           + esc(it.correct ? (window.__IQ_REPORT_T.verdict_ok || '') : (window.__IQ_REPORT_T.verdict_bad || ''))
           + '</span>';
        h += '</div>';
        h += '<p class="iq-offer-item-text">' + esc(it.text) + '</p>';
        h += '</div>';
    });

    var rest = Math.max(0, (total || 0) - items.length);
    if (rest > 0) {
        h += '<div class="iq-offer-locked">' + esc(T('locked', { n: rest })) + '</div>';
    }
    host.innerHTML = h;
}

/**
 * Дверь оплаты. Продаём ДОКУМЕНТ, а не пакет токенов.
 *
 * ⚠️ Замер 08.08–26.08.2026: кнопка обещала «Войти и получить разбор», а
 * открывавшаяся панель называлась «Пополнить токены· 8000 за 99 ₽». Панель
 * открыли 476 раз, «Купить» нажали 12. Человека после теста просили СТАТЬ
 * ДЕРЖАТЕЛЕМ ТОКЕНОВ — купи пакет, потом потрать часть на документ, — то есть
 * принять три решения вместо одного. Ровно это уже разобрано и исправлено у
 * теста уровня языка (решение Фарида 15.08), причём обосновано замером ИМЕННО
 * на этом туле; сюда та форма не доехала.
 *
 * Токены не исчезают — они становятся внутренней механикой, и остаток честно
 * назван в подписи под кнопкой. Рублёвой кассы нет (интернациональные локали
 * идут своей витриной) — остаётся прежняя формулировка, ничего не ломая.
 *
 * `data-tmb-purpose-*` доедет до кассы не сейчас, а к нажатию «Купить»: атрибуты
 * дописывает saveRun() ответом сервера (см. token-wall.js, purposeAtBuyTime).
 */
function payLinkHtml(act) {
    var pay = CFG && CFG.pay;

    /* Polar (интернациональные локали): касса открывается модалкой по кнопке,
     * а не по ссылке, — и только ВОШЕДШЕМУ: у Polar нет гостевой кассы,
     * аккаунт сначала. Гость видит дверь входа, результат при этом переживает
     * уход (stash + серверный прогон). Цена — в валюте покупателя по его гео,
     * посчитана сервером из той же суммы, по которой Polar спишет. */
    if (pay && pay.rail === 'polar') {
        if (!CFG.logged_in) {
            return '<button class="iq-btn" type="button" data-iq-offer="login">' + esc(T('login_first')) + '</button>'
                 + '<div class="iq-offer-note">' + esc(T('result_kept')) + '</div>';
        }
        var h1 = '';
        if (pay.consent) {
            // Явное согласие (EU): без него отказ от права на возврат ничтожен.
            // Сервер кассы требует его сам; здесь — чтобы человек его увидел.
            h1 += '<label class="iq-offer-consent"><input type="checkbox" id="iqOfferConsent"> <span>'
                + esc(pay.consent) + '</span></label>';
        }
        // Ярлык уже несёт валюту ($3.99 / €3.99) — ключ без «₽».
        h1 += '<button class="iq-btn" type="button" data-iq-offer="polar-buy">' + esc(T('pay_intl', { n: pay.label }) || pay.label) + '</button>';
        if (T('pay_note_intl')) {
            h1 += '<div class="iq-offer-note">' + esc(T('pay_note_intl', { n: pay.more || 0 })) + '</div>';
        }
        return h1;
    }

    /* ── ДЕНЕЖНАЯ ДВЕРЬ ─────────────────────────────────────────────────
     * Документ есть в каталоге сервера — покупаем НАПРЯМУЮ: почта плюс
     * карта, без кошелька и без формы регистрации. Прежний путь («купи
     * пакет → заведи аккаунт → вернись → потрать часть») стоил 14 979
     * показов оффера на три оплаты. Токенная ветка ниже остаётся тем, у
     * кого токены уже есть, и локалям без рублёвой кассы. */
    var doc = CFG.docs && CFG.docs.iq_report;
    if (doc && doc.rub > 0 && act !== 'login') {
        var dLabel = T('pay_rub', { n: doc.rub });
        var dh = '<a class="iq-btn"'
               + ' data-tmb-doc="' + esc(doc.code) + '"'
               + ' data-tmb-doc-price="' + esc(doc.rub) + '"'
               + ' data-tmb-title="' + esc(T('wall_title', { n: doc.rub }) || dLabel) + '"'
               + ' data-tmb-purpose="iq_report"'
               + ' data-tmb-purpose-locale="' + esc(window.__LOCALE || 'en') + '"'
               + ' data-iq-offer="' + act + '" href="' + esc(CFG.store_url) + '">'
               + esc(dLabel) + '</a>';
        // ⚠️ «Остаток пакета останется на балансе» — про ТОКЕННУЮ рельсу.
        // У денежной двери пакета нет, и та же строка обещала бы токены,
        // которых человек не получит.
        return dh;
    }

    var label = pay ? T('pay_rub', { n: pay.price_rub }) : T(act === 'topup' ? 'topup' : 'login_first');
    var short = Math.max(0, (CFG.cost || 0) - (CFG.balance || 0));

    var h = '<a class="iq-btn" data-tmb-topup="1"'
          + ' data-tmb-short="' + short + '"'
          // Заголовок кассы = обещание этой кнопки. Без него панель говорила о
          // нехватке токенов там, где кнопка обещала документ за рубли.
          + (pay ? ' data-tmb-title="' + esc(T('wall_title', { n: pay.price_rub }) || label) + '"' : '')
          + (pay ? ' data-tmb-pack="' + esc(pay.pack) + '"' : '')
          + ' data-tmb-purpose="iq_report"'
          + ' data-tmb-purpose-locale="' + esc(window.__LOCALE || 'en') + '"'
          + ' data-iq-offer="' + act + '" href="' + esc(CFG.store_url) + '">'
          + esc(label) + '</a>';

    if (pay && T('pay_note')) {
        h += '<div class="iq-offer-note">' + esc(T('pay_note')) + '</div>';
    }

    return h;
}

/**
 * Что осталось в этом блоке после 16.09.2026: ТОЛЬКО поле имени.
 *
 * Все двери — план, токены, рубли, вход — переехали в общую карточку
 * <x-perk-gate> под баллом. Держать их и здесь значило бы иметь две двери
 * к одному документу с двумя независимыми правилами: ровно так у четырёх
 * документов сайта получилось четыре разных ответа на вопрос «сколько это
 * стоит», и один из них был «Премиуму — платно».
 *
 * Имя осталось здесь намеренно: оно печатается НА документе, относится к
 * содержимому, а не к оплате, и спрашивать его в карточке рядом с ценой
 * значило бы превращать её в форму.
 */
function renderActions() {
    var host = document.getElementById('iqOfferActions');
    if (!host || !CFG) return;

    var h = '';

    /* ⚠️ ИНТЕРНАЦИОНАЛЬНАЯ РЕЛЬСА ОСТАЁТСЯ ЗДЕСЬ. Карточка перка знает про
     * рублёвую кассу (DocumentCatalog отдаёт её только ру-локалям) и про
     * токены, но одношаговой покупки документа через Polar у неё нет. Убрать
     * отсюда двери целиком значило бы разменять один клик на два ровно у той
     * аудитории, которая рублями не платит. Поэтому на рельсе Polar блок
     * работает как прежде, а на рублёвой — молчит, отдав двери карточке. */
    var polarRail = !!(CFG.pay && CFG.pay.rail === 'polar');

    // Имя в сертификате — необязательное. Пустое печатает отчёт без строки
    // «выдан», а не пустую строку: сертификат с пустым именем выглядит браком.
    if (CFG.logged_in) {
        h += '<label class="iq-offer-name">';
        h += '<span>' + esc(T('name_label')) + '</span>';
        h += '<input type="text" id="iqOfferName" maxlength="' + (CFG.max_name || 60) + '" autocomplete="name">';
        h += '<small>' + esc(T('name_hint')) + '</small>';
        h += '</label>';
    }

    if (polarRail) {
        if (!CFG.logged_in) {
            h += CFG.store_url
                ? payLinkHtml('guest-buy')
                : '<button class="iq-btn" type="button" data-iq-offer="login">' + esc(T('login_first')) + '</button>';
        } else if (!CFG.free_for_me && (CFG.balance || 0) < CFG.cost) {
            h += payLinkHtml('topup');
        }
    }

    host.innerHTML = h;
}

/**
 * Перенести карточку перка под балл и объявить, что с ней делать.
 *
 * Карточку рисует блейд (её тексты, цена плана и ссылки — серверные), а
 * карточка результата собирается строкой в JS, поэтому элемент ПЕРЕЕЗЖАЕТ
 * в свой слот, а не создаётся заново. Тот же приём, что у token-wall с
 * блоком СБП.
 */
function relocateGate() {
    /* ⚠️⚠️ Карточку ищем в документе ОДИН раз, дальше держим ссылку.
     *
     * После переноса она живёт внутри экрана результата, а экран — строка в
     * #iqPanels: любая его перерисовка (тест заново без перезагрузки, возраст,
     * указанный на экране результата) выносит карточку из документа вместе со
     * старой разметкой. querySelector её больше не находил, и новый результат
     * оставался без двери к разбору вовсе — ни плана, ни рублей, ни токенов.
     * Замер 16–23.09.2026 (RU): карточка отрисовывается у 96 % результатов,
     * после повтора теста без перезагрузки — у 0 из 77; возраст на экране
     * результата указывают в 28 % прогонов, и каждый такой раз уносил её.
     * Сам узел при этом цел — на нём обработчики и состояние perk-gate.js, —
     * и его достаточно вернуть в новый слот. */
    GATE = GATE || document.querySelector('[data-perk-gate][data-perk="iq_report"]');
    var slot = document.getElementById('iqPerkSlot');
    if (GATE && slot && GATE.parentNode !== slot) slot.appendChild(GATE);

    if (!window.__perkGate || relocateGate.done) return;
    relocateGate.done = true;

    window.__perkGate.register('iq_report', {
        /* Отложить прогон на сервере. Без него вебхуку нечего выдавать, а
         * документ остаётся заложником вкладки: замер 26.08 — из троих
         * заплативших двое вернулись из кассы на пустой экран. */
        park: function () {
            return saveRun(null).then(function (run) {
                if (!run) return null;
                var nameEl = document.getElementById('iqOfferName');
                return { ref: run.id, token: run.token, name: nameEl ? nameEl.value : '' };
            });
        },
        /* Выдать документ. Бесплатно по перку или за токены решает СЕРВЕР —
         * здесь один и тот же вызов, и страница не пытается угадать цену. */
        issue: function () { return buy(); },
        onIssued: function (res) {
            if (res && res.download) renderPurchased(res.download);
        }
    });
}

/** Состояние «уже куплено»: повторная выдача того же файла без цены на кнопке. */
function renderPurchased(url) {
    var host = document.getElementById('iqOfferActions');
    if (!host) return;
    PURCHASED_URL = url;

    var again = (window.__IQ_REPORT_T || {}).download_again
        || (window.__IQ_REPORT_T || {}).doc_download
        || T('buy');

    host.innerHTML = '<button class="iq-btn secondary" type="button" data-iq-offer="again">'
        + esc(again) + '</button>'
        + (CFG && !CFG.free_for_me && typeof CFG.balance === 'number'
            ? '<div class="iq-offer-note">' + esc(T('balance', { n: CFG.balance })) + '</div>'
            : '');
}

function status(msg, kind) {
    var el = document.getElementById('iqOfferStatus');
    if (!el) return;
    el.textContent = msg || '';
    el.className = 'iq-offer-status' + (kind ? ' ' + kind : '');
}

/* ── Графики страницы в PNG ────────────────────────────────────────────── */

function chartPng(id) {
    var c = document.getElementById(id);
    if (!c || !c.toDataURL) return null;
    try {
        var url = c.toDataURL('image/png');
        // Пустой холст даёт крошечный data-URL; такой график в документе хуже,
        // чем его отсутствие — страница просто не станет его печатать.
        return (url && url.length > 2000) ? url : null;
    } catch (e) { return null; }
}

/* ── Покупка ───────────────────────────────────────────────────────────── */

/**
 * Выдать разбор и ОТДАТЬ ОТВЕТ ВЫЗЫВАЮЩЕМУ.
 *
 * Промис появился вместе с карточкой перка: ей нужно знать, состоялась ли
 * выдача, чтобы перерисовать остаток и не оставить кнопку «Готовим…»
 * навсегда. Отказ — это `{ok:false}`, а не брошенное исключение: карточка
 * обязана показать человеку фразу, а не молча погаснуть.
 */
function buy() {
    if (BUSY || !RESULT) return Promise.resolve({ ok: false, error: 'busy' });
    BUSY = true;
    status(T('building'));

    var nameEl = document.getElementById('iqOfferName');
    var payload = {
        result: toServerShape(RESULT),
        holder_name: nameEl ? nameEl.value : '',
        locale: window.__LOCALE || document.documentElement.lang || 'en',
        taken_at: RESULT.taken_at || null,
        charts: { bell: chartPng('iqBellCanvas'), radar: chartPng('iqRadarCanvas') }
    };

    return post('/api/iq-report', payload).then(function (j) {
        BUSY = false;
        if (!j || !j.ok) {
            if (j && j.__status === 402) {
                status(T('insufficient'), 'bad');
                CFG.balance = j.balance;
                renderActions();
                return { ok: false, error: 'insufficient' };
            }
            if (j && j.__status === 401) {
                stash(RESULT);
                goLogin();
                return { ok: false, error: 'auth' };
            }
            status(T('failed'), 'bad');
            return { ok: false, error: 'failed' };
        }

        if (typeof j.balance === 'number' && CFG) CFG.balance = j.balance;
        status('');
        download(j.download);

        // Кнопка «купить» после покупки превращается в «скачать ещё раз».
        // Сервер и так не спишет за тот же результат дважды, но приглашать
        // человека нажать ту же кнопку с той же ценой на ней — значит внушать,
        // что он сейчас заплатит снова.
        renderPurchased(j.download);
        return { ok: true, download: j.download };
    }).catch(function () {
        BUSY = false;
        status(T('failed'), 'bad');
        return { ok: false, error: 'network' };
    });
}

/**
 * Забираем файл через blob и общий примитив: прямой переход по ссылке увёл бы
 * человека со страницы результата, а `<a download href>` на blob молча
 * не работает в Android WebView (за это в проекте отвечает __downloadFile).
 */
function download(url) {
    fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.blob() : Promise.reject(r.status); })
        .then(function (blob) {
            var name = 'timbrica-iq-' + (RESULT && RESULT.iq ? RESULT.iq : 'report') + '.pdf';
            if (window.__downloadFile) window.__downloadFile(blob, name);
            else window.location.href = url;
        })
        .catch(function () { window.location.href = url; });
}

function goLogin() {
    var here = window.location.pathname + window.location.search;
    // Локаль в префиксе обязательна: голый /login уводит в чужой язык (а на
    // части конфигураций — в 404), и человек теряет результат теста на ровном
    // месте. Берём её из страницы, а не из первого сегмента пути: у страницы
    // она уже разобрана и не зависит от формы адреса.
    var loc = window.__LOCALE || (here.split('/')[1] || 'en');
    window.location.href = '/' + loc + '/login?redirect=' + encodeURIComponent(here);
}

/* ── Публичный вход ────────────────────────────────────────────────────── */

function mount(result) {
    RESULT = result || RESULT;
    if (!RESULT) return;

    /* Результат на экране сменился: тест прошли заново без перезагрузки или
     * балл пересчитан по возрасту. Отложенный прогон описывает ПРЕЖНИЙ, и касса
     * повезла бы его номер — человек заплатил бы за разбор не того результата,
     * который видит. */
    if (RUN_FOR && RUN_FOR !== fingerprint(RESULT)) forgetRun();

    var host = document.getElementById('iqOfferSlot');
    if (!host) return;
    host.innerHTML = offerHtml();
    // Карточка обязана встать под балл ДО ответа /info: место она занимает
    // сразу, а содержимое дорисует своим запросом.
    relocateGate();

    host.addEventListener('click', function (e) {
        var t = e.target.closest('[data-iq-offer]');
        if (!t) return;
        var act = t.getAttribute('data-iq-offer');

        /* ⚠️ Телеметрии КЛИКА не было вовсе — только `report_offer_shown`.
         * Поэтому на вопрос «сколько человек вообще нажали и где отвалились»
         * ответить было нечем: 1428 показов и ноль покупок не различают
         * «не захотели» и «нажали, но дверь не открылась». Меряем намерение. */
        if (window.__aeFunnel) {
            window.__aeFunnel('report_offer_cta', { act: act, logged: !!(CFG && CFG.logged_in) });
        }

        if (act === 'buy') { buy(); }
        if (act === 'polar-buy') { buyViaPolar(t); }
        if (act === 'again' && PURCHASED_URL) { download(PURCHASED_URL); }
        if (act === 'login') { stash(RESULT); goLogin(); }
        // guest-buy / topup — настоящие ссылки: их перехватывает token-wall.js
        // и раскрывает панель на месте. Результат кладём на всякий случай:
        // не построится панель — клик уйдёт по ссылке, и он должен пережить уход.
        if (act === 'guest-buy' || act === 'topup') { stash(RESULT); saveRun(t); }
    });

    // Пока /info не ответил, блок действий обязан быть НЕ пустым: пустая
    // область под текстом оффера читается как «тут ничего не будет», и человек
    // уходит до того, как появится кнопка. Заглушка занимает то же место.
    var actionsHost = document.getElementById('iqOfferActions');
    if (actionsHost) {
        actionsHost.innerHTML = '<div class="iq-offer-note iq-offer-loading">'
            + esc(T('building') || '…') + '</div>';
    }

    // Локаль ОБЯЗАНА ехать в запросе: `/api/*` живёт без языкового префикса,
    // и на сервере глобальная локаль на нём разрешается не в ту.
    fetch(infoUrl(), { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
            if (!j || !j.enabled) { host.innerHTML = ''; return; }
            CFG = j;
            renderActions();
            relocateGate();
            // Вернулся из кассы — забрать оплаченное ДО того, как он начнёт
            // искать файл сам.
            claimPaid();
            if (window.__aeFunnel) window.__aeFunnel('report_offer_shown', { pro: !!j.free_for_me, logged: !!j.logged_in });
        })
        .catch(function () { host.innerHTML = ''; });

    var itemsCsv = RESULT.itemsCsv || RESULT.items || '';
    if (itemsCsv) {
        post('/api/iq-report/preview', { items: itemsCsv, locale: window.__LOCALE })
            .then(function (j) { if (j && j.ok) renderTeaser(j.items, j.total); })
            .catch(function () {});
    }
}

/**
 * Отложить прогон НА СЕРВЕРЕ и пометить им ссылку оплаты.
 *
 * ⚠️ Зачем, если результат уже лежит в localStorage. Хранилище браузера
 * переживает навигацию, но не переживает ДРУГОЙ браузер, приватное окно,
 * очистку и сутки. Замер 26.08.2026: из трёх заплативших за разбор двое не
 * получили ничего — возвращались из кассы на пустой стартовый экран, потеряв
 * двадцать минут теста вместе с деньгами (возврат #22). С серверным прогоном
 * документ собирает вебхук, даже если вкладку закрыли на шаге оплаты.
 *
 * Зовётся при НАМЕРЕНИИ купить, а не на каждом результате: показов оффера
 * 14 979 против 517 нажатий, и хранить данные тех, кто ничего не просил, — это
 * лишняя приватная поверхность без пользы.
 *
 * Провал НЕ мешает покупке: без назначения касса просто вернёт человека в тул
 * (tool_return), где его ждёт восстановленный результат и кнопка «Скачать
 * разбор» — на один клик длиннее, но целиком рабочий путь.
 */
function saveRun(link) {
    if (!RESULT) return Promise.resolve(null);
    /* Складываем прогон только там, где платёж СМОЖЕТ его донести: обе кассы
     * (рублёвая панель и Polar) несут назначение, и признак у них общий —
     * `CFG.pay`. Нет кассы — нет и прогона: хранить чужой результат теста,
     * который никто не заберёт, незачем; там работает возврат через
     * localStorage, оживший первым коммитом этой серии. */
    // ⚠️ Денежная дверь — тоже касса, и она тоже несёт назначение. Условие
    // «есть CFG.pay» пришло из времён, когда рельса была одна; без второй
    // половины прогон не откладывался бы, и покупка документа упиралась бы в
    // «покупать нечего» ровно там, где деньги уже показаны.
    if (!CFG || !(CFG.pay || (CFG.docs && CFG.docs.iq_report))) return Promise.resolve(null);
    if (RUN_SAVED) return RUN_SAVED;

    var nameEl = document.getElementById('iqOfferName');

    RUN_FOR = fingerprint(RESULT);
    var mine = RUN_SAVED = post('/api/iq-report/run', {
        result: toServerShape(RESULT),
        holder_name: nameEl ? nameEl.value : '',
        locale: window.__LOCALE || document.documentElement.lang || 'en',
        taken_at: RESULT.taken_at || null,
        charts: { bell: chartPng('iqBellCanvas'), radar: chartPng('iqRadarCanvas') }
    }).then(function (j) {
        /* Ответ мог прийти, когда этот прогон уже забыт: результат на экране
         * сменился, пока шёл запрос (forgetRun). Тогда он не вправе ни метить
         * ссылку, ни сбрасывать состояние, заведённое уже для нового. */
        var current = RUN_SAVED === mine;
        if (!j || !j.ok) { if (current) { RUN_SAVED = null; RUN_FOR = ''; } return null; }
        if (window.__aeFunnel) window.__aeFunnel('report_run_saved', { id: j.id });
        if (!current) return null;
        if (link) {
            link.setAttribute('data-tmb-purpose-ref', String(j.id));
            link.setAttribute('data-tmb-purpose-token', String(j.token));
            if (nameEl && nameEl.value) link.setAttribute('data-tmb-purpose-name', nameEl.value);
        }
        return { id: j.id, token: j.token };
    }).catch(function () { if (RUN_SAVED === mine) { RUN_SAVED = null; RUN_FOR = ''; } return null; });

    return mine;
}

/**
 * Забыть отложенный прогон — и в карточке перка тоже.
 *
 * Карточка держит СВОЙ промис откладывания и номер прогона в денежной ссылке:
 * без setContext она отдала бы кассе прежний номер, даже когда здесь его уже
 * нет. Пустой контекст сбрасывает и то, и другое (perk-gate.js).
 */
function forgetRun() {
    RUN_SAVED = null;
    RUN_FOR = '';
    PURCHASED_URL = null;
    try { if (window.__perkGate) window.__perkGate.setContext('iq_report', {}); } catch (e) {}
}

/**
 * Покупка через Polar: аккаунт уже есть, касса — модалкой поверх страницы.
 *
 * Порядок: сперва прогон на сервер (без него платёж не знает, за что он),
 * потом сессия кассы с назначением, потом модалка. Не открылась модалка —
 * уходим на hosted-страницу Polar, как везде на сайте (fail-open); вернёт
 * success_url, который сервер собрал из назначения: /iq-test?iq_paid=<прогон>.
 */
function buyViaPolar(btn) {
    if (BUSY || !CFG || !CFG.pay || CFG.pay.rail !== 'polar') return;
    var consent = document.getElementById('iqOfferConsent');
    if (consent && !consent.checked) {
        status(CFG.pay.consent_req || '', 'bad');
        try { consent.focus(); } catch (_) {}
        return;
    }
    BUSY = true;
    if (btn) btn.disabled = true;
    status(T('building'));

    var nameEl = document.getElementById('iqOfferName');

    saveRun(null).then(function (run) {
        var body = {
            package: CFG.pay.pack,
            locale: window.__LOCALE || document.documentElement.lang || 'en',
            consent: true
        };
        if (run) {
            body.purpose        = 'iq_report';
            body.purpose_ref    = run.id;
            body.purpose_token  = run.token;
            body.purpose_locale = body.locale;
            if (nameEl && nameEl.value) body.purpose_name = nameEl.value;
        }
        if (window.__aeFunnel) window.__aeFunnel('report_polar_start', { run: run ? run.id : 0 });
        return post(CFG.pay.start_url, body);
    }).then(function (j) {
        BUSY = false;
        if (btn) btn.disabled = false;
        if (!j || !j.url) { status(T('failed'), 'bad'); return; }
        status('');
        if (window.__polarCheckout && typeof window.__polarCheckout.open === 'function') {
            window.__polarCheckout.open(j.url, {});
        } else {
            window.location.href = j.url;
        }
    }).catch(function () {
        BUSY = false;
        if (btn) btn.disabled = false;
        status(T('failed'), 'bad');
    });
}

/**
 * Возвращение из кассы: `?iq_paid=<номер прогона>`.
 *
 * Документ к этому моменту почти всегда уже собран вебхуком, поэтому запрос
 * попадает в «уже есть» и НЕ списывает второй раз. Зачем тогда вообще:
 * покупатель возвращается на страницу и должен ПОЛУЧИТЬ файл, а не искать его —
 * именно поиском закончилась история, из-за которой всё это написано.
 */
function claimPaid() {
    var m = /[?&]iq_paid=(\d+)/.exec(window.location.search || '');
    // Не вошёл — забирать нечем: прогон принадлежит покупателю, и запрос
    // ответил бы 401, показав человеку ошибку вместо его же документа.
    if (!m || !CFG || !CFG.logged_in || CLAIMED) return;
    CLAIMED = true;

    // Адрес чистим сразу: перезагрузка не должна выглядеть как вторая покупка,
    // а ссылка с номером прогона — гулять по мессенджерам.
    try {
        var clean = window.location.pathname
            + window.location.search.replace(/([?&])iq_paid=\d+&?/, '$1').replace(/[?&]$/, '');
        window.history.replaceState({}, '', clean);
    } catch (_) {}

    if (window.__aeFunnel) window.__aeFunnel('report_paid_return', { run: m[1] });
    status(T('claiming') || T('building'));

    post('/api/iq-report/claim', { run_id: +m[1] }).then(function (j) {
        if (!j || !j.ok) { status(T('failed'), 'bad'); return; }
        status('');
        download(j.download);
        renderPurchased(j.download);
        if (CFG && typeof j.balance === 'number') CFG.balance = j.balance;
    }).catch(function () { status(T('failed'), 'bad'); });
}

/** Результат, отложенный перед уходом на регистрацию (если он есть). */
function pending() {
    return unstash();
}

/**
 * Возврат из кассы БЕЗ восстановленного результата.
 *
 * ⚠️ Без этого весь серверный прогон был бы бесполезен, и я едва не оставил
 * дыру ровно там, где её и чинил: забор оплаченного висел внутри mount(), а
 * mount() случается только когда на экране ЕСТЬ результат — то есть снова
 * зависел от браузера. Человек, заплативший с телефона, в приватном окне или
 * вернувшийся через сутки, увидел бы обычный стартовый экран, имея на сервере
 * готовый оплаченный документ.
 *
 * Поэтому возврат обрабатывается САМ, на загрузке страницы, и не нуждается ни
 * в разметке оффера, ни в результате: файл просто отдаётся общим примитивом
 * скачивания.
 */
function bootstrapPaidReturn() {
    if (!/[?&]iq_paid=\d+/.test(window.location.search || '')) return;

    // Локаль ОБЯЗАНА ехать в запросе: `/api/*` живёт без языкового префикса,
    // и на сервере глобальная локаль на нём разрешается не в ту.
    fetch(infoUrl(), { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
            if (!j || !j.enabled) return;
            CFG = CFG || j;
            claimPaid();
        })
        .catch(function () {});
}

/* Отложенные скрипты исполняются ДО DOMContentLoaded — значит обработчик
 * события отработает и когда модуль подключён через defer. */
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrapPaidReturn);
} else {
    bootstrapPaidReturn();
}

window.IQReportOffer = {
    mount: mount,
    pending: pending,
    clearPending: clearStash,
    stash: stash
};

})();
